<template>
  <div class="wrapper-app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>




export default {
  name: 'app',
  data() {
    return {
    }
  },
  computed:{
    isAuthenticated:function(){
      console.log('this.$store.getters.isAuthenticated',this.$store.getters.isAuthenticated);
      return this.$store.getters.isAuthenticated
    }
  },
  methods:{


  },
  mounted(){
    console.log('app mounted');
    if(isMobile()){
      this.$router.push('/mobile');
    }
  }

}



</script>

<style>

</style>
